import { Moment } from "moment";
import { Route } from "./route";
import { Schedule } from "./schedule";
import { Stop } from "./stop";
import { SegmentedLeafletRail } from "./rail";

export class Segment {
    routeId: number;
    scheduleId: number;
    startInfo: SegmentInfo;
    finishInfo: SegmentInfo;
}

export class SegmentInfo {
    stopId: number;
    time: Date
}

export class EnhancedSegment {
    private _segment: Segment;
    private _startStop: Stop;
    private _finishStop: Stop;

    route: Route;
    schedule: Schedule;

    get startStop(): Stop {
        if (!this._startStop) {
            if (this.stops.length > 0)
                this._startStop = this.stops[0];
        }

        return this._startStop;
    }
    get finishStop(): Stop {
        if (!this._finishStop) {
            if (this.stops.length > 1)
                this._finishStop = this.stops[this.stops.length - 1];
        }

        return this._finishStop;
    }

    stops: Stop[];
    rails: SegmentedLeafletRail[];

    get startTime(): Date {
        if (this._segment)
            return null;
        return this._segment.startInfo.time;
    }
    get finishTime(): Date {
        if (this._segment)
            return null;
        return this._segment.finishInfo.time;
    }

    constructor(segment: Segment) {
        this._segment = segment;
        this.stops = [];
        this.rails = [];
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/segment.ts